<template>
  <div class="dev-wrapper">
    <ExamForm :exam="mockExam" :loading="false" @save="onSave" @cancel="onCancel" @change="onChange" />
  </div>
  
</template>

<script setup lang="ts">
import { provide } from "vue";
import ExamForm from "@/modules/exam-listing-lab/ExamForm.vue";
import type { EnhancedLabPermissions } from "@/modules/exam-listing-lab/types/lab";
import { FeegowLabApi } from "@/utils/feegow-lab";

const permissions: EnhancedLabPermissions = {
  cadastroexamesV: 1,
  cadastroexamesI: 1,
  cadastroexamesA: 1,
  cadastroexamesX: 1,
  isAllowed: () => true,
};

provide("labPermissions", permissions);

// Insere um token dummy para evitar erros de token em chamadas acidentais
try {
  window.localStorage.setItem("tk", "dev-token");
} catch {}

// Mock simples dos endpoints usados pelo ExamForm
const mockSamples = [
  { id: 101, CodAmostra: "B01", descamostra: "Sangue Total" },
  { id: 102, CodAmostra: "U01", descamostra: "Urina" },
];

const mockProcedures = [
  { id: 201, NomeProcedimento: "Hemograma Completo" },
  { id: 202, NomeProcedimento: "Glicemia Jejum" },
];

(FeegowLabApi as any).getSamplesByLab = async () => mockSamples;
(FeegowLabApi as any).getProcedures = async () => mockProcedures;
(FeegowLabApi as any).insertExamLicense = async () => ({ success: true });
(FeegowLabApi as any).updateExamLicense = async () => ({ success: true });
(FeegowLabApi as any).fetchExamDetails = async () => ({ success: true });

const mockExam = {
  id: 123,
  labID: 5,
  amostraID: 101,
  codExame: "HB001",
  nomeExame: "Hemograma",
  correspondingProcedureId: 201,
  correspondingProcedureName: "Hemograma Completo",
  tipoMaterial: "Sangue",
  metodologia: "Automatizada",
  camposAdicionais: "Jejum: 8h",
  conservante: "EDTA",
  diasParaResultado: 2,
  diasAdicionais: "",
  camposObrigatorios: { volume: true, altura: false, peso: false, regiao: false },
  ObsExame: true,
  IdadeGestacional: false,
  ultimaMenstruacaoData: false,
  FertilizacaoInVitro: false,
  IdadeMae: false,
  CadeiaCustodia: false,
};

function onSave() {}
function onCancel() {}
function onChange() {}

</script>

<style scoped>
.dev-wrapper {
  padding: 16px;
}

</style>


